module.exports = __webpack_public_path__ + "img/car.bb403e61.svg";